import { render, staticRenderFns } from "./business-process.vue?vue&type=template&id=01e6d9e6&scoped=true&"
import script from "./business-process.vue?vue&type=script&lang=js&"
export * from "./business-process.vue?vue&type=script&lang=js&"
import style0 from "./business-process.vue?vue&type=style&index=0&id=01e6d9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e6d9e6",
  null
  
)

export default component.exports